// =====================================================
// Color swatch click → fetch images → animate replace
// =====================================================
(function () {
  function addLoaded() {
      document.body.classList.add('page-loaded');
  }

  if (document.readyState === 'complete') {
    addLoaded();
  } else {
    window.addEventListener('load', addLoaded);
  }
})();



  /* ---------------------------------
   * Swatch click listener
   * --------------------------------- */
 document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.prod-info__option__colors .color-swatch');
  if (!swatch) return;

  const startUrl = location.href;

  function waitForUrl() {
    if (location.href !== startUrl) {
      fetchAndReplaceGrid(location.href);
    } else {
      requestAnimationFrame(waitForUrl);
    }
  }

  waitForUrl();
});


let controller;

function fetchAndReplaceGrid(url) {
  if (controller) controller.abort();
  controller = new AbortController();

  fetch(url, { signal: controller.signal })
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('.grid-left-wrapper.product__images');
      const newInfo = doc.querySelector('product-images.product__images');
      const newTitle = doc.querySelector('h1.product__title');
      const newPrice = doc.querySelector('.price__regular');
      const newBreadcrumb = doc.querySelector('.theme-breadcrumbs-section');
      const newTabs = doc.querySelector('.product-tabs');

      requestAnimationFrame(() => {
        const currentGrid = document.querySelector('.grid-left-wrapper.product__images');
        const currentInfo = document.querySelector('product-images.product__images');
        const currentTitle = document.querySelector('h1.product__title');
        const currentPrice = document.querySelector('.price__regular');
        const currentBreadcrumb = document.querySelector('.theme-breadcrumbs-section');
        const currentTabs = document.querySelector('.product-tabs');
        
        if (newTitle && currentTitle) {
          currentTitle.replaceWith(newTitle.cloneNode(true));
        }

        if (newPrice && currentPrice) {
          currentPrice.replaceWith(newPrice.cloneNode(true));
        }

        if (newBreadcrumb && currentBreadcrumb) {
          currentBreadcrumb.replaceWith(newBreadcrumb.cloneNode(true));
        }

        if (newGrid && currentGrid) {
          currentGrid.replaceWith(newGrid.cloneNode(true));
        }

        if (newInfo && currentInfo) {
          currentInfo.replaceWith(newInfo.cloneNode(true));
        }

        if (newTabs && currentTabs) {
          currentTabs.replaceWith(newTabs.cloneNode(true));
        }
     
      });
    })
    .catch(err => {
      if (err.name !== 'AbortError') console.error(err);
    });
}


document.addEventListener('click', function (e) {
  const thumb = e.target.closest('.grid-left-thumb');
  if (!thumb) return;

  e.preventDefault();

  const index = thumb.dataset.index;
  const wrapper = thumb.closest('.grid-left-wrapper');
  if (!wrapper) return;

  const mainGrid = wrapper.querySelector('.grid-left-main');
  if (!mainGrid) return;

  const targetItem = mainGrid.querySelector(
    `.grid-item[data-index="${index}"]`
  );

  if (!targetItem) return;

  /* 🔥 MOVE CLICKED IMAGE TO FIRST POSITION */
  mainGrid.prepend(targetItem);

  /* 🔹 UPDATE ACTIVE THUMB */
  wrapper
    .querySelectorAll('.grid-left-thumb.active-thumb')
    .forEach(el => el.classList.remove('active-thumb'));

  thumb.classList.add('active-thumb');
  
});

/* ----------------------------------
   * Grid image → open fullscreen gallery
   * ---------------------------------- */
  document.addEventListener('click', function (e) {
    const img = e.target.closest('.main-grid-img');
    if (!img) return;
 
    img.style.cursor = 'zoom-in';
 
    const clickedFull = img.dataset.full?.replace(/\?.*$/, '');
    if (!clickedFull) return;
 
    const slides = document.querySelectorAll('.product__photo');
 
    for (const slide of slides) {
      const slideSrc = slide.dataset.imageSrc?.replace(/\?.*$/, '');
      if (slideSrc && slideSrc.includes(clickedFull)) {
        slide.click();
        return;
      }
    }
 
    // Fallback
    slides[0]?.click();
  });


/* -------------- Replaces product gallery images with videos when the image ALT contains a .mp4 URL ------------ */

document.addEventListener('DOMContentLoaded', function () {
  requestAnimationFrame(function () {
    initAltVideoReplacement();
  });
});

function initAltVideoReplacement() {
  let unlocked = false;

  function unlockVideos() {
    unlocked = true;
    document.querySelectorAll('video').forEach(v => {
      v.play().catch(() => {});
    });

    window.removeEventListener('touchstart', unlockVideos);
    window.removeEventListener('click', unlockVideos);
    window.removeEventListener('scroll', unlockVideos);
  }

  function run() {
    document.querySelectorAll(
      '.product__slide[data-type="image"] img'
    ).forEach(function (img) {
      if (img.dataset.videoDone) return;

      var alt = img.getAttribute('alt');
      if (!alt || !alt.includes('.mp4')) return;

      img.dataset.videoDone = 'true';

      var video = document.createElement('video');
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.autoplay = true;
      video.controls = true;
      video.src = alt;

      video.style.width = '100%';
      video.style.height = '100%';
      video.style.objectFit = 'cover';

      var figure = img.closest('figure');
      if (!figure) return;

      figure.innerHTML = '';
      figure.appendChild(video);

      video.play().catch(() => {});
      if (unlocked) video.play().catch(() => {});
    });
  }

  // Initial run
  run();

  // Observe dynamic changes
  new MutationObserver(run).observe(
    document.querySelector('product-images') || document.body,
    { childList: true, subtree: true }
  );

  // Mobile autoplay unlock
  window.addEventListener('touchstart', unlockVideos, { once: true });
  window.addEventListener('click', unlockVideos, { once: true });
  window.addEventListener('scroll', unlockVideos, { once: true });
}
